import { motion } from "framer-motion";

const chapters = [
  {
    n: "01",
    icon: "🔥",
    title: "Be first to know",
    text: "The exact moment the reveal drops around Teacher's Day — straight to your phone.",
  },
  {
    n: "02",
    icon: "🎁",
    title: "Early access, first",
    text: "Step into limited-availability offers before they're open to everyone else.",
  },
  {
    n: "03",
    icon: "📚",
    title: "Insider info",
    text: "Exclusive details on courses, books &amp; the full MIK ecosystem, before it opens up.",
  },
  {
    n: "04",
    icon: "⚡",
    title: "Don't be late",
    text: "Some offers may run out fast. Hear about it first — not from someone else.",
  },
];

const item = {
  hidden: { opacity: 0, y: 28 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, delay: i * 0.1, ease: "easeOut" },
  }),
};

export const WhyJoin = () => (
  <section className="relative px-5 py-20 sm:px-8 sm:py-28" data-testid="why-join-section">
    <div className="mx-auto max-w-3xl">
      <motion.h2
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="font-display text-center text-2xl font-bold text-white sm:text-3xl"
      >
        Why join <span className="text-[#0f93cc]">First Access</span>
      </motion.h2>

      <div className="mt-12 space-y-6">
        {chapters.map((c, i) => (
          <motion.div
            key={c.n}
            custom={i}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-60px" }}
            variants={item}
            className="flex items-start gap-5 rounded-2xl border border-white/10 bg-white/[0.03] p-5 backdrop-blur-sm sm:p-6"
            data-testid={`why-join-item-${c.n}`}
          >
            <span className="font-display text-3xl font-black text-white/10 sm:text-4xl">
              {c.n}
            </span>
            <div>
              <div className="flex items-center gap-2">
                <span className="text-xl" aria-hidden="true">{c.icon}</span>
                <h3 className="font-display text-base font-semibold text-white sm:text-lg">
                  {c.title}
                </h3>
              </div>
              <p
                className="mt-1.5 text-sm text-white/60 sm:text-base"
                dangerouslySetInnerHTML={{ __html: c.text }}
              />
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
